import * as React from 'react'
import styled from 'styled-components'
import Svg from './Svg'

function BaseComponent(props: any) {
  return (
    <Svg
      width={15}
      height={15}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 1l-.577 1.003L1.175 12 .6 13h13.8l-.575-1-5.748-9.997L7.5 1zm0 2.006L2.329 12H12.67L7.5 3.006z"
        fill="currentColor"
      />
    </Svg>
  )
}

const SvgVercelLogo = styled(BaseComponent)`
  outline: none;
`
export default SvgVercelLogo
